import React, { createContext, useContext } from 'react';

/**
 * Contexto que define qué instancia del estado de usuario (userDetail) se está usando.
 * Ejemplo: "main", "dialog", "alarm", etc.
 */
export const UserDetailContext = createContext<string>('main');

/**
 * Hook para leer el contexto actual.
 */
export const useUserDetailContext = (): string => {
  return useContext(UserDetailContext);
};

/**
 * Componente Provider que puedes envolver alrededor de UserInfo, UserContent, etc.
 */
export const UserDetailContextProvider = ({
                                            contextKey,
                                            children,
                                          }: {
  contextKey?: string;
  children: React.ReactNode;
}) => {
  return (
    <UserDetailContext.Provider value={contextKey ?? 'main'}>
      {children}
    </UserDetailContext.Provider>
  );
};